export default {
  inject: {
    rootMenu: {
      from: "mm-menu",
      default: null,
    },
  },
  computed: {
    indexPath() {
      const path = [this.index]
      let parent = this.$parent
      while (parent.$options.name !== "mm-menu") {
        if (parent.index) {
          path.unshift(parent.index)
        }
        parent = parent.$parent
      }
      return path
    },
    parentMenu() {
      let parent = this.$parent
      while (parent && ["mm-menu", "mm-submenu"].indexOf(parent.$options.name) === -1) {
        parent = parent.$parent
      }
      return parent
    },
    paddingStyle() {
      if (this.rootMenu.mode !== "vertical") {
        return {}
      }

      let padding = 20
      let parent = this.$parent

      if (this.rootMenu.collapse) {
        padding = 20
      } else {
        while (parent && parent.$options.name !== "mm-menu") {
          if (parent.$options.name === "mm-submenu") {
            padding += 20
          }
          parent = parent.$parent
        }
      }
      return { paddingLeft: padding + "px" }
    },
  },
}
